import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "../locales/en/translation";
import { fr } from "../locales/fr/translation";

const resources = {
    en,
    fr,
}

export const availableLanguages = Object.keys(resources)

i18n.use(initReactI18next)
    .init({
        //debug: true,
        resources,
        fallbackLng: "en",
    });